import { useMutation, UseMutationOptions, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { subscriptionQueryOptions } from '../../utils/queryOptions';
import { apiV1 } from '../../utils/apiClient';
import { message, Switch } from 'antd';
import { SubscriptionAttrs } from '@next-is-free-monorepo/next-is-free-types';
import { NButton } from '@next-is-free-monorepo/nif-web-components';
import ChoosePlanModal from './ChoosePlanModal';
import { useState } from 'react';


const ToggleAutoRenew = () => {

  const { data: subscription } = useSuspenseQuery(subscriptionQueryOptions());

  const [choosePlanModal, setChoosePlanModal] = useState(false);

  const queryClient = useQueryClient();
  const toggleAutoRenewMutation: UseMutationOptions = {
    mutationKey: ['subscription', 'renew'],
    mutationFn: async () => apiV1.put(`/shop/subscription/${subscription.id}/auto-renew/${subscription.cancel_at_period_end}`, {}),
    onMutate: async (newTodo) => {
      queryClient.setQueryData(['subscription'], (old: SubscriptionAttrs) => ({
        ...old,
        cancel_at_period_end: !old.cancel_at_period_end
      }));
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['upcoming-invoice'] });
      message.success('Impostazioni di rinnovo aggiornate');
    }
  };

  const toggleAutoRenew = useMutation(toggleAutoRenewMutation);

  if (!subscription.is_subscription_valid) {
    return (<div />);
  }

  if (subscription.cancel_at_period_end && subscription.status === 'trialing') {
    return (
      <div className={'p-5 border rounded-2xl'}>
        <p className={'text-lg font-bold'}>Scegli il tuo piano</p>
        <p>Stai utilizzando la prova gratuita del piano Advanced, che terminerà
          tra {subscription.trial_days_left} giorni. Scegli ora il tuo per evitare interruzioni al termine della prova
          gratis. L’abbonamento scelto si rinnoverà automaticamente a partire dal {subscription.renewal_date}.</p>
        <div className={'text-right mt-4'}>
          <NButton onClick={() => setChoosePlanModal(true)}>Scegli il mio piano</NButton>
        </div>
        <ChoosePlanModal enableAllPlans type={'default'} enableAutoRenewal={true} open={choosePlanModal}
                         onClose={() => setChoosePlanModal(false)} />
      </div>
    );
  }

  return (
    <div>
      <div className={'p-5 border rounded-2xl flex justify-between items-center gap-4'}>
        <div>
          <p className={'font-bold'}>Rinnovo
            automatico {!subscription.cancel_at_period_end ? 'attivo' : 'disattivato'}</p>
          <p className={'text-balance text-sm text-slate-500'}>Attiva il rinnovo automatico per evitare interruzioni al
            termine del periodo di
            fatturazione corrente</p>
        </div>
        <div>
          <Switch loading={toggleAutoRenew.isPending} checked={!subscription.cancel_at_period_end} onChange={() => toggleAutoRenew.mutate()} />
        </div>
      </div>
    </div>);
};
export default ToggleAutoRenew;
